<h2 class="thm-page-title ng-star-inserted"> E-Posta Adresi Doğrulama </h2>

<thm-data-loader *ngIf="!hataVarMi && basvuruId !== undefined && basvuruId !== ''" path="iletisim/e-posta-dogrulama-sayfasi-bilgi-getir" 
    [params]="{ basvuruTuru: basvuruTuru, basvuruId: basvuruId, ePosta: ePosta, onayKodu: onayKodu }" 
    (errorOccurred)="bilgiGetirmedeHataAlindi($event)">
    <ng-template let-data>

        <div class="email-update">

            <div *ngIf="!data.gecerlilikSuresiDolduMu" class="alert alert-success my-alert">
                <h6 class="alert-heading"><i class="fa fa-check" aria-hidden="true"></i> Tebrikler !</h6>
                <hr>
                <span>
                    E-Posta adresiniz başarıyla güncellendi.
                </span>
            </div>
            <div *ngIf="data.gecerlilikSuresiDolduMu" class="alert alert-danger my-alert">
                <h6 class="alert-heading"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Başarısız İşlem !</h6>
                <hr>
                <span [innerHTML]="data.gecerlilikSuresiDolduMesaji | safeHtml"></span>
            </div>
            <div class="text-center">
                <div class="input-area">
                    <thm-button *ngIf="data.loginOlunduMu" buttonType="primary"
                                iconClass="fa fa-arrow-circle-left"
                                (clicked)="anaSayfayaGit()">
                        Anasayfa'ya Dön
                    </thm-button>
                    <thm-button *ngIf="!data.loginOlunduMu" buttonType="success"
                                iconClass="fas fa-key" 
                                (clicked)="login()">
                        Giriş Yap
                    </thm-button>
                    <thm-action-button *ngIf="data.gecerlilikSuresiDolduMu" path="iletisim/e-posta-onay-kodunu-tekrar-gonder-dis" 
                                        [params]="{ basvuruTuru: basvuruTuru, basvuruId: basvuruId, strBasvuruId: basvuruId, bilgi: ePosta }" 
                                        (actionPerformed)="ePostaOnayKoduGonderildi()" (errorOccurred)="ePostaOnayKoduGonderimdeHataAlindi($event)"
                                        buttonType="primary" iconClass="fas fa-angle-double-right">
                        Kodu Tekrar Gönder
                    </thm-action-button>
                </div>
            </div>
            
        </div>

    </ng-template>
</thm-data-loader>

<div *ngIf="hataVarMi" class="alert alert-danger my-alert">
    <h6 class="alert-heading"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Başarısız İşlem !</h6>
    <hr>
    <span>
        {{hataMesaji}}
    </span>
</div>
